$(function() {

	$('#views-button-container').each(function() {

		// Container
		var $container = $(this);

		// Filter
		$container.find('.filter-views a').click(function() {
			$container.find('.filter-views li').removeClass('active');
			$(this).parent().addClass('active');
			$container[$(this).hasClass('all') ? 'addClass' : 'removeClass']('all');
			return false;
		});

		// Click
		$container.find('a.view-dialogue').click(function() {
			if ($(this).parent().hasClass('disabled')) return false;
			$container.removeClass('open');
		});

		// Actions
		$container.find('.view-action a').click(function() {

			// Disabled
			if ($(this).parent().hasClass('disabled')) return false;

			// Action
			var action = $(this).attr('data-action');

			// Rename
			if (action == 'rename') {
				var newName = window.prompt('Choose a new name', $(this).attr('data-name'));
				if (newName) window.location.href = window.location.href + '&viewaction=rename&viewname=' + newName;
				return false;
			}

			// Duplicate
			else if (action == 'duplicate') {
				var newName = window.prompt('Choose a name', $(this).attr('data-name'));
				if (newName) window.location.href = window.location.href + '&viewaction=duplicate&viewname=' + newName;
				return false;
			}

			// Delete
			else if (action == 'delete') {
				if (!confirm('Delete the view "' + $(this).attr('data-name') + '"?')) return false;
			}

		});

	})

});